import React, {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {PageTitle} from '../../_metronic/layout/core'
import {UiIcon} from '../../components/UiIcon'
import {Activity, ActivityFile, activityApi} from '../../services/education/activity.service'
import {ActivityState} from './ActivityLibrary'
import './Activity.scss'

export function ActivityDetail() {
  const {id = ''} = useParams()
  return <ActivityContent key={id} id={id}/>
}
function ActivityContent({id}: {id: string}) {
  const [activity, setActivity] = useState<Activity>()
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  const [selected, setSelected] = useState<ActivityFile>()
  useEffect(() => {
    let active = true
    setActivity(undefined); setSelected(undefined); setError(false)
    activityApi.detail(id).then(value => {
      if (active) {setActivity(value); setSelected(value.files[0])}
    }).catch(() => {if (active) setError(true)})
    return () => {active = false}
  }, [id, retry])
  return <div className='activity-library'>
    <PageTitle description='Etkinlik içeriğini inceleyin, dosyaları açarak sınıfınızla kullanın.'>{activity?.name || 'Etkinlik detayı'}</PageTitle>
    <Link className='activity-back-link' to='/activities'>← Tüm etkinlikler</Link>
    {!activity ? <ActivityState error={error} onRetry={() => setRetry(value => value + 1)}/> : <div className='activity-detail-layout'>
      <aside className='activity-info'>
        <span className='activity-symbol'><UiIcon name='activity' size={28}/></span><h2>Etkinlik hakkında</h2>
        <dl>{[
          ['Sınıf seviyesi', activity.gradeLevel?.title], ['Kategori', activity.category?.name], ['Tema', activity.theme?.name],
          ['Öğrenme alanı', activity.learningArea?.title], ['Ünite', activity.unit?.title],
        ].filter(([, value]) => value).map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
        {activity.outcome && <section className='activity-outcome'><h3>Kazanım</h3><p>{activity.outcome}</p></section>}
      </aside>
      <section className='activity-files' aria-labelledby='activity-files-title'>
        <div className='activity-files-heading'><div><h2 id='activity-files-title'>Etkinlik dosyaları</h2><p>Görüntülemek istediğiniz dosyayı seçin.</p></div><span className='activity-tag'>{activity.files.length} dosya</span></div>
        {activity.files.length === 0 ? <p className='activity-state'>Bu etkinliğe ait dosya bulunamadı.</p> : <>
          <div className='activity-file-list'>{activity.files.map(file => <button type='button' key={file.id} className={`activity-file-choice${file.id === selected?.id ? ' is-selected' : ''}`} aria-pressed={file.id === selected?.id} onClick={() => setSelected(file)}><UiIcon name='file' size={22}/><span><strong>{file.name}</strong><small>{file.mimeType === 'application/pdf' ? 'PDF' : 'PNG'} · {file.size < 1024 * 1024 ? `${Math.max(1, Math.round(file.size / 1024))} KB` : `${(file.size / 1024 / 1024).toFixed(1)} MB`}</small></span>{file.id === selected?.id && <UiIcon name='check' size={18}/>}</button>)}</div>
          {selected && <ActivityFilePreview key={selected.id} activityId={activity.id} file={selected}/>}
        </>}
      </section>
    </div>}
  </div>
}

export function ActivityFilePreview({activityId, file}: {activityId: string | number; file: ActivityFile}) {
  const [url, setUrl] = useState('')
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setUrl(''); setError(false)
    activityApi.fileUrl(activityId, file.id).then(result => {
      if (new URL(result.url).protocol !== 'https:') throw new Error('Invalid file URL')
      if (active) setUrl(result.url)
    }).catch(() => {if (active) setError(true)})
    return () => {active = false}
  }, [activityId, file.id, retry])
  return <div className='activity-file-preview'>
    {error ? <div className='activity-state' role='alert'><h3>Dosya görüntülenemedi</h3><button className='activity-button' onClick={() => setRetry(value => value + 1)}>Tekrar dene</button></div> : !url ? <div className='activity-state' role='status'>Dosya hazırlanıyor…</div> : <>
      <div className='activity-preview-toolbar'><span>Önizleme</span><a className='activity-button' href={url} target='_blank' rel='noopener noreferrer'>Dosyayı aç<UiIcon name='external' size={17}/><span className='visually-hidden'> (yeni sekme)</span></a></div>
      {file.mimeType === 'application/pdf' ? <iframe title={`${file.name} önizlemesi`} src={url}/> : <img src={url} alt={file.name} onError={() => setError(true)}/>}
      <p className='activity-preview-hint'>Dosyayı yeni sekmede açarak indirebilir veya yazdırabilirsiniz. Önizleme açılmıyorsa <button className='activity-text-button' onClick={() => setRetry(value => value + 1)}>yenileyin</button>.</p>
    </>}
  </div>
}
